import React from 'react';

const QuoteExpired: React.FC = () => {
  return (
    <div className="page-container" data-testid="QuoteExpired">
      <p className="text-center max-w-4xl text-4xl text-primary font-raleway">
        Quote is expired.
      </p>
    </div>
  );
};

export default QuoteExpired;
